import { UnitType } from '@exodus/currency'

const name = 'ravencoin'
const displayName = 'Ravencoin'
const ticker = 'RVN'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#EE5239'
const gradientColors = ['#F59233', '#EE5239']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  RVN: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://ravencoin.network/address/${address}`,
  txUrl: (txId) => `https://ravencoin.network/tx/${txId}`,
}
const info = {
  description:
    'Ravencoin is an open source peer to peer electronic system for the creation and transfer of assets. It is a community-driven project similar to bitcoin with no coins or rewards held for founders or developers. It features a 1 minute blocktime and is designed to be ASIC resistant to prevent mining centralization.',
  reddit: 'https://www.reddit.com/r/Ravencoin/',
  twitter: 'https://twitter.com/ravencoin',
  website: 'https://ravencoin.org/',
  telegram: 'https://t.me/RavencoinDev',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
